import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/Contact.css';
import { motion } from 'framer-motion';

const Contact = () => {
  const fade = {
    opacity: 1,
    transition: {
      duration: 1.5,
    },
  };

  const verticalLeft = {
    opacity: 1,
    y: 0,
    transition: {
      duration: 1.5,
    },
  };

  return (
    <>
      <div className="contact" id="contact">
        <div className="container">
          <motion.div
            className="heading"
            initial={{ opacity: 0 }}
            whileInView={fade}
            viewport={{ once: true }}
          >
            <p className="heading-sub-text">Hire Me</p>
            <p className="heading-text">Get in Touch</p>
          </motion.div>
          <div className="contact-box">
            <motion.div
              className="left-box"
              initial={{ opacity: 0, y: '-50px' }}
              whileInView={verticalLeft}
            >
              <div className="contact-heading">
                <p>
                  I am interested in any available opportunities especially
                  ambitious projects. However, if you have other request or
                  question, do not hesitate to use the form.
                </p>
              </div>
              <div className="contact-hello">
                <p>Say Hello</p>
                <Link
                  className="hello-links"
                  to="//wa.me/+905338688158"
                  target="_blank"
                >
                  wa.me/aseni
                </Link>
                <Link
                  className="hello-links"
                  to="//mailto:alujallo@gmail.com"
                  target="_blank"
                >
                  alujallo@gmail.com
                </Link>
              </div>
            </motion.div>
            <motion.div
              className="right-box"
              initial={{ opacity: 0, y: '50px' }}
              whileInView={verticalLeft}
            >
              <form
                name="contact-form"
                method="POST"
                data-netlify="true"
                action="POST"
              >
                <input type="hidden" name="form-name" value="contact-form" />
                <div className="form-top">
                  <div className="name">
                    <label htmlFor="name">
                      Your Name
                      <input
                        type="text"
                        name="name"
                        id="name"
                        placeholder="Enter your name"
                        required
                      />
                    </label>
                  </div>

                  <div className="email">
                    <label htmlFor="email">
                      Your Email
                      <input
                        type="email"
                        name="email"
                        id="email"
                        placeholder="Enter your email address"
                        required
                      />
                    </label>
                  </div>
                </div>

                <div className="form-mid">
                  <div className="message">
                    <label htmlFor="message">
                      Your message
                      <textarea
                        type="text"
                        name="message"
                        id="message"
                        placeholder="Hello, are you available to talk?"
                        required
                      />
                    </label>
                  </div>
                </div>

                <div className="form-btn">
                  <button type="submit" className="hero-contact">
                    Send Message
                  </button>
                </div>
              </form>
            </motion.div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Contact;
